(function () {
  function normalize(value) {
    return (value || "").toLowerCase().trim();
  }

  function initFaqHub(root) {
    var search = root.querySelector("[data-faq-search]");
    var searchSubmit = root.querySelector("[data-faq-search-submit]");
    var chips = Array.prototype.slice.call(root.querySelectorAll("[data-faq-category]"));
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-faq-group]"));
    var items = Array.prototype.slice.call(root.querySelectorAll("[data-faq-item]"));
    var empty = root.querySelector("[data-faq-empty]");
    var activeCategory = "all";
    var highlightTimer = null;

    function applyFilters() {
      var query = normalize(search && search.value);
      var visibleTotal = 0;

      items.forEach(function (item) {
        var category = item.getAttribute("data-category");
        var haystack = item.getAttribute("data-search-text") || "";
        var categoryMatch = activeCategory === "all" || category === activeCategory;
        var searchMatch = query === "" || haystack.indexOf(query) !== -1;
        var isVisible = categoryMatch && searchMatch;

        item.hidden = !isVisible;
        if (isVisible) {
          visibleTotal += 1;
        } else {
          item.removeAttribute("open");
        }
      });

      groups.forEach(function (group) {
        var visibleItems = group.querySelectorAll("[data-faq-item]:not([hidden])").length;
        group.hidden = visibleItems === 0;
      });

      if (empty) {
        empty.hidden = visibleTotal !== 0;
      }
    }

    function getScrollOffset() {
      var nav = root.querySelector(".faq-hub__nav-wrap");
      var navHeight = nav ? nav.getBoundingClientRect().height : 0;
      return navHeight + 96;
    }

    function getSearchTarget() {
      var firstVisibleItem = items.find(function (item) {
        return !item.hidden;
      });

      if (firstVisibleItem) {
        return firstVisibleItem;
      }

      if (empty && !empty.hidden) {
        return empty;
      }

      return groups.find(function (group) {
        return !group.hidden;
      }) || null;
    }

    function highlightTarget(target) {
      if (!target) return;

      if (highlightTimer) {
        window.clearTimeout(highlightTimer);
      }

      root.querySelectorAll(".is-search-target").forEach(function (element) {
        element.classList.remove("is-search-target");
      });

      target.classList.add("is-search-target");
      highlightTimer = window.setTimeout(function () {
        target.classList.remove("is-search-target");
      }, 1400);
    }

    function scrollToSearchResults() {
      applyFilters();

      var target = getSearchTarget();
      if (!target) return;

      var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
      window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth"
      });

      highlightTarget(target);
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        activeCategory = chip.getAttribute("data-faq-category") || "all";
        if (search && search.value) {
          search.value = "";
        }
        chips.forEach(function (button) {
          button.classList.toggle("is-active", button === chip);
        });
        applyFilters();

        var target = root.querySelector('[data-faq-group][data-category="' + activeCategory + '"]');
        if (activeCategory !== "all" && target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    if (search) {
      search.addEventListener("input", function () {
        if (search.value && activeCategory !== "all") {
          activeCategory = "all";
          chips.forEach(function (button) {
            button.classList.toggle("is-active", (button.getAttribute("data-faq-category") || "all") === "all");
          });
        }
        applyFilters();
      });

      search.addEventListener("keydown", function (event) {
        if (event.key !== "Enter") {
          return;
        }

        event.preventDefault();
        scrollToSearchResults();
      });
    }

    if (searchSubmit) {
      searchSubmit.addEventListener("click", function () {
        scrollToSearchResults();
      });
    }

    items.forEach(function (item) {
      var summary = item.querySelector("summary");
      if (!summary) {
        return;
      }
      summary.addEventListener("click", function () {
        if (item.open) {
          return;
        }
        items.forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.removeAttribute("open");
          }
        });
      });
    });

    applyFilters();
  }

  function boot() {
    document.querySelectorAll("[data-faq-hub]").forEach(initFaqHub);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
